﻿export class SearchComplaints {
    languageId: number;
    pageNumber: number;
    pageSize: number;
    title: string;
    complaintUniq: string;
    categoryId: number;
    statusId: number;
    organizationId: number;
    column: string;
    isDesc: boolean;

}